export default __webpack_public_path__ + "img/delivery_img/67.gif";